import React from 'react';
import { DollarSign, TrendingUp } from 'lucide-react';

const PortfolioSummary = ({ totalAum, ytdReturn, textColor, isLoading }) => {
  const formattedAum = totalAum 
    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(totalAum)
    : 'N/A';
  
  const formattedReturn = ytdReturn !== undefined && ytdReturn !== null
    ? `${ytdReturn > 0 ? '+' : ''}${parseFloat(ytdReturn).toFixed(2)}%`
    : 'N/A';
  
  const returnColor = ytdReturn > 0 ? 'text-green-600' : ytdReturn < 0 ? 'text-red-600' : '';
  const percentageValue = ytdReturn !== undefined && ytdReturn !== null 
    ? Math.min(Math.max(Math.abs(parseFloat(ytdReturn)) * 5, 5), 100)
    : 0;
  
  return (
    <div className="flex-1 min-w-[200px] bg-gradient-to-br from-blue-50 to-white p-3 rounded-lg shadow-sm border border-blue-100">
      <h3 className="text-base font-medium mb-2" style={{ color: textColor || 'inherit' }}>
        Portfolio Summary
      </h3>
      
      {isLoading ? (
        <div className="animate-pulse">
          <div className="h-5 bg-gray-200 rounded w-3/4 mb-2"></div>
          <div className="h-5 bg-gray-200 rounded w-1/2"></div>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-2 mb-3">
            <div className="p-1.5 bg-blue-100 rounded-full">
              <DollarSign size={16} className="text-primaryDark" />
            </div>
            <div>
              <p className="text-xs text-gray-500" style={{ color: textColor ? `${textColor}99` : 'inherit' }}>
                Current Value
              </p>
              <p className="text-lg font-semibold" style={{ color: textColor || 'inherit' }}>
                {formattedAum}
              </p>
            </div>
          </div>
          
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <div className="p-1.5 bg-blue-100 rounded-full">
                <TrendingUp size={16} className={ytdReturn >= 0 ? "text-green-600" : "text-red-600"} />
              </div>
              <div className="flex-1">
                <p className="text-xs text-gray-500" style={{ color: textColor ? `${textColor}99` : 'inherit' }}>
                  YTD Return
                </p>
                <p className={`text-lg font-semibold ${returnColor}`} style={{ color: returnColor ? 'inherit' : textColor }}>
                  {formattedReturn}
                </p>
              </div>
            </div>
            
            {ytdReturn !== undefined && ytdReturn !== null && (
              <div className="mt-1">
                <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
                  <div 
                    className={`h-full ${ytdReturn >= 0 ? 'bg-green-500' : 'bg-red-500'}`} 
                    style={{ width: `${percentageValue}%`, transition: 'width 1s ease-out' }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PortfolioSummary;